import { FETCH_GROUP_CONVERSATION_LIKES } from './ActionTypes';

export const fetchGroupConversationLikes = (
    userGroupPk,
    resourceId,
    resourceType,
    start,
    limit,
    connectionStatusIncluded
) => ({
    type: FETCH_GROUP_CONVERSATION_LIKES,
    payload: { userGroupPk, resourceId, resourceType, start, limit, connectionStatusIncluded }
});
